// extracted by mini-css-extract-plugin
module.exports = {"placeholderTile":"Placeholder_placeholderTile__2Js0P","container":"Placeholder_container__1qrBA"};